import './FreeMonthsByRepByMonthPage.css'
import { Row, Col } from 'react-bootstrap'
import { ICustomColumn, IPageProps, IRootState } from 'types'
import { FormDateSpanSelector, FormDropDownList, PageHeader, ReturnButton } from 'components'
import { V1ApiReportsClient } from 'core/http-common'
import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { FreeMonthDto } from '@v1ReportsApi'
import toast from 'core/toast'
import { Label } from '@progress/kendo-react-labels'
import { Skeleton } from '@progress/kendo-react-indicators'
import SAGrid, { ISAGridRef } from 'components/Grid/SAGrid'
import { GridCellProps, GridFooterCellProps, GridHeaderCellProps } from '@progress/kendo-react-grid'
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns'
import { Field, Form, FormElement, FormHandle, FormRenderProps } from '@progress/kendo-react-form'
import { IFormDateSpanSelectorRef, RelativeDateOptionId } from 'components/Form/FormDateSpanSelector'
import moment from 'moment'

const FreeMonthsByRepByMonthPage = ({ title }: IPageProps) => {

    const formDateSpanSelectorRef = useRef<IFormDateSpanSelectorRef>(null)
    const formRef = useRef<FormHandle>(null)

    const repStatuses = [
        { text: 'All', id: 1 },
        { text: 'Active', id: 2 },
        { text: 'InActive', id: 3 }
    ]
    const [state, setState] = useState({
        value: { text: 'Active', id: 2 }
    })
    const [loaded, setLoaded] = useState(false)

    const defaultStartDate = moment().startOf('year').toDate()
    const defaultEndDate = moment().endOf('year').toDate()

    const defaultValues = {
        repStatus: repStatuses.find(x => x.text === 'Active'),
        startDate: defaultStartDate,
        endDate: defaultEndDate
    }

    const dateOptions = [
        RelativeDateOptionId.ThisYear,
        RelativeDateOptionId.LastYear
    ]

    const gridRef = useRef<ISAGridRef>(null)
    const loading = useSelector((state: IRootState) => state.app.loading)

    const [reps, setReps] = useState<Array<FreeMonthDto>>([])

    const totalCell = (props: GridFooterCellProps) => {
        var total = 0
        if (props.field === 'january')
            total = reps.reduce((freeMonth, current) => freeMonth + current.january, 0)
        else if (props.field === 'february')
            total = reps.reduce((freeMonth, current) => freeMonth + current.february, 0)
        else if (props.field === 'march')
            total = reps.reduce((freeMonth, current) => freeMonth + current.march, 0)
        else if (props.field === 'april')
            total = reps.reduce((freeMonth, current) => freeMonth + current.april, 0)
        else if (props.field === 'may')
            total = reps.reduce((freeMonth, current) => freeMonth + current.may, 0)
        else if (props.field === 'june')
            total = reps.reduce((freeMonth, current) => freeMonth + current.june, 0)
        else if (props.field === 'july')
            total = reps.reduce((freeMonth, current) => freeMonth + current.july, 0)
        else if (props.field === 'august')
            total = reps.reduce((freeMonth, current) => freeMonth + current.august, 0)
        else if (props.field === 'september')
            total = reps.reduce((freeMonth, current) => freeMonth + current.september, 0)
        else if (props.field === 'october')
            total = reps.reduce((freeMonth, current) => freeMonth + current.october, 0)
        else if (props.field === 'november')
            total = reps.reduce((freeMonth, current) => freeMonth + current.november, 0)
        else if (props.field === 'december')
            total = reps.reduce((freeMonth, current) => freeMonth + current.december, 0)
        else if (props.field === 'totalFreeMonths')
            total = reps.reduce((freeMonth, current) => freeMonth + current.totalFreeMonths, 0)
        return (
            <td colSpan={props.colSpan} style={props.style}>
                Total: {total}
            </td>
        )
    }

    const numberColumnCell = (props: GridCellProps) => {
        var total = 0
        if (props.field === 'january')
            total = props.dataItem.january
        else if (props.field === 'february')
            total = props.dataItem.february
        else if (props.field === 'march')
            total = props.dataItem.march
        else if (props.field === 'april')
            total = props.dataItem.april
        else if (props.field === 'may')
            total = props.dataItem.may
        else if (props.field === 'june')
            total = props.dataItem.june
        else if (props.field === 'july')
            total = props.dataItem.july
        else if (props.field === 'august')
            total = props.dataItem.august
        else if (props.field === 'september')
            total = props.dataItem.september
        else if (props.field === 'october')
            total = props.dataItem.october
        else if (props.field === 'november')
            total = props.dataItem.november
        else if (props.field === 'december')
            total = props.dataItem.december
        return (
            <td className='text-center'>
                {total}
            </td>
        )
    }

    const headerColumnCell = (props: GridHeaderCellProps) => {

        return (
            <>
                <b>{props.title}</b>
            </>
        )
    }

    const totalColumnCell = (props: GridCellProps) => {
        if (!props.dataItem.totalFreeMonths) return <td></td>

        return (
            <td className='text-center'>
                <b>{props.dataItem.totalFreeMonths}</b>
            </td>
        )
    }

    const freeMonthsColumns: ICustomColumn[] = [
        { field: 'salesPerson', title: 'Sales Person' },
        { field: 'january', title: 'Jan', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell, headerClassName: 'k-table-th' },
        { field: 'february', title: 'Feb', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'march', title: 'Mar', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'april', title: 'Apr', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'may', title: 'May', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'june', title: 'Jun', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'july', title: 'Jul', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'august', title: 'Aug', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'september', title: 'Sep', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'october', title: 'Oct', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'november', title: 'Nov', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'december', title: 'Dec', filterType: 'numeric', footerCell: totalCell, cell: numberColumnCell, headerCell: headerColumnCell },
        { field: 'totalFreeMonths', title: 'Total', filterType: 'numeric', footerCell: totalCell, cell: totalColumnCell, headerCell: headerColumnCell },
    ]

    const handleChange = (event: DropDownListChangeEvent) => {
        setState({
            value: event.target.value
        })
    }

    const fetch = async () => {
        let values = formRef.current?.values
        console.log('fetching values')
        console.log(values)
        try {
            const result = await V1ApiReportsClient.getFreeMonthsByRepByMonth(
                state.value.id,
                values?.startDate ? values.startDate : defaultStartDate,
                values?.endDate ? values.endDate : defaultEndDate
            )
            setReps(result.data)
            setLoaded(true)
        }
        catch (e) {
            toast.responseErrors(e)
        }
    }

    useEffect(() => {
        fetch()
    }, [state.value])

    const searchByDate = async (start: Date, end: Date) => {
        formRef.current?.valueSetter('startDate', start)
        formRef.current?.valueSetter('endDate', end)
        fetch()
    }

    return (
        <div id='FreeMonthsByRepByMonthPage'>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/reports' />
            </PageHeader>
            <Form
                ref={formRef}
                ignoreModified={true}
                initialValues={defaultValues}
                render={(formRenderProps: FormRenderProps) => (
                    <FormElement>
                        <div className='bg-light border rounded p-3 shadow-sm mb-3'>
                            <Row>
                                <Col lg={4}>
                                    <Field
                                        label='Rep Status:'
                                        name='repStatus'
                                        textField='text'
                                        dataItemKey='id'
                                        data={repStatuses}
                                        value={state.value}
                                        component={FormDropDownList}
                                        onChange={handleChange}
                                    />
                                </Col>
                                <Col lg={8}>
                                    <FormDateSpanSelector
                                        ref={formDateSpanSelectorRef}
                                        className=''
                                        formRenderProps={formRenderProps}
                                        onSearch={searchByDate}
                                        disabled={loading}
                                        includeRelativeDateOptions={dateOptions}
                                        defaultRelativeDateOption={RelativeDateOptionId.ThisYear}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </FormElement>
                )}
            />
            <Row>
                <Col>
                    {!loaded ? <Skeleton shape='rectangle' style={{ width: '100%', height: '500px' }} animation={{ type: 'pulse' }} />
                        :
                        <SAGrid
                            features={
                                {
                                    pageable: false,
                                    sortable: true,
                                    filterable: false,
                                    exportToExcel: true,
                                    exportToPDF: false
                                }
                            }
                            ref={gridRef}
                            data={reps}
                            columns={freeMonthsColumns}
                            defaultSort={[{ field: 'salesPerson', dir: 'asc' }]}
                        />
                    }
                </Col>
            </Row>
        </div>
    )
}
export default FreeMonthsByRepByMonthPage
